import { Link } from '@aws-amplify/ui-react';
import { ChannelIcons } from '../utils/constants';
import '../styles/channelStyles.css'

const logoStyle = {
    container: {
      backgroundPosition: "center center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain"
    }
  }

function Channels() {
    return (
        <div className="app-content">
            <div className='nbcu-channel-section'>
                <div className="view-content-wrapper">
                    <div className="brands-grid">
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[0].href}>
                                            <img className="channel-images" src={ChannelIcons[0].image_src} alt={ChannelIcons[0].text} width="200" height="150"></img>
                                        </Link>
                                        <p className="brand-tile-region">East</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[1].href}>
                                            <img className="channel-images" src={ChannelIcons[1].image_src} alt={ChannelIcons[1].text} width="200" height="150"></img>
                                        </Link>
                                        <p className="brand-tile-region">East</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[2].href}>
                                            <img className="channel-images" src={ChannelIcons[2].image_src} alt={ChannelIcons[2].text} width="200" height="150"></img>
                                        </Link>   
                                        <p className="brand-tile-region">West</p>                                                            
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[3].href}>
                                            <img className="channel-images" src={ChannelIcons[3].image_src} alt={ChannelIcons[3].text} width="200" height="150"></img>
                                        </Link>  
                                        <p className="brand-tile-region">West</p>                                                                                              
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[4].href}>
                                            <img className="channel-images" src={ChannelIcons[4].image_src} alt={ChannelIcons[4].text} width="200" height="150"></img>
                                        </Link>       
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[5].href}>
                                            <img className="channel-images" src={ChannelIcons[5].image_src} alt={ChannelIcons[5].text} width="200" height="150"></img>
                                        </Link>   
                                        <p className="brand-tile-region">KNBC</p>                                 
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[6].href}>
                                            <img className="channel-images" src={ChannelIcons[6].image_src} alt={ChannelIcons[6].text} width="200" height="150"></img>
                                        </Link>    
                                        <p className="brand-tile-region">KNSD</p>                                                               
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[7].href}>
                                            <img className="channel-images" src={ChannelIcons[7].image_src} alt={ChannelIcons[7].text} width="200" height="150"></img>
                                        </Link>      
                                        <p className="brand-tile-region">KNTV</p>                                                             
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[8].href}>
                                            <img className="channel-images" src={ChannelIcons[8].image_src} alt={ChannelIcons[8].text} width="200" height="150"></img>
                                        </Link> 
                                        <p className="brand-tile-region">KXAS</p>                                                                                                
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[9].href}>
                                            <img className="channel-images" src={ChannelIcons[9].image_src} alt={ChannelIcons[9].text} width="200" height="150"></img>
                                        </Link>     
                                        <p className="brand-tile-region">WBTS</p>                               
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[10].href}>
                                            <img className="channel-images" src={ChannelIcons[10].image_src} alt={ChannelIcons[10].text} width="200" height="150"></img>
                                        </Link>     
                                        <p className="brand-tile-region">WCAU</p>                               
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[11].href}>
                                            <img className="channel-images" src={ChannelIcons[11].image_src} alt={ChannelIcons[11].text} width="200" height="150"></img>
                                        </Link>     
                                        <p className="brand-tile-region">WMAQ</p>                               
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[12].href}>
                                            <img className="channel-images" src={ChannelIcons[12].image_src} alt={ChannelIcons[12].text} width="200" height="150"></img>
                                        </Link>       
                                        <p className="brand-tile-region">WNBC</p>                                                            
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[13].href}>
                                            <img className="channel-images" src={ChannelIcons[13].image_src} alt={ChannelIcons[13].text} width="200" height="150"></img>
                                        </Link>       
                                        <p className="brand-tile-region">WRC</p>                                                            
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[14].href}>
                                            <img className="channel-images" src={ChannelIcons[14].image_src} alt={ChannelIcons[14].text} width="200" height="150"></img>
                                        </Link>       
                                        <p className="brand-tile-region">WTVJ</p>                                                            
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[15].href}>
                                            <img className="channel-images" src={ChannelIcons[15].image_src} alt={ChannelIcons[15].text} width="200" height="150"></img>
                                        </Link>       
                                        <p className="brand-tile-region">WVIT</p>                                                            
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[16].href}>
                                            <img className="channel-images" src={ChannelIcons[16].image_src} alt={ChannelIcons[16].text} width="200" height="150"></img>
                                        </Link>       
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[17].href}>
                                            <img className="channel-images" src={ChannelIcons[17].image_src} alt={ChannelIcons[17].text} width="200" height="150"></img>
                                        </Link>       
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[18].href}>
                                            <img className="channel-images" src={ChannelIcons[18].image_src} alt={ChannelIcons[18].text} width="200" height="150"></img>
                                        </Link>       
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[19].href}>
                                            <img className="channel-images" src={ChannelIcons[19].image_src} alt={ChannelIcons[19].text} width="200" height="150"></img>
                                        </Link>       
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[20].href}>
                                            <img className="channel-images" src={ChannelIcons[20].image_src} alt={ChannelIcons[20].text} width="200" height="150"></img>
                                        </Link>       
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="versant-channel-section">
                <div className="view-content-wrapper">
                    <div className="brands-grid">
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[21].href}>
                                            <img className="channel-images" src={ChannelIcons[21].image_src} alt={ChannelIcons[21].text} width="200" height="150"></img>
                                        </Link>      
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[22].href}>
                                            <img className="channel-images" src={ChannelIcons[22].image_src} alt={ChannelIcons[22].text} width="200" height="150"></img>
                                        </Link>      
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[23].href}>
                                            <img className="channel-images" src={ChannelIcons[23].image_src} alt={ChannelIcons[23].text} width="200" height="150"></img>
                                        </Link>   
                                        <p className="brand-tile-region">East</p>                                                                
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[24].href}>
                                            <img className="channel-images" src={ChannelIcons[24].image_src} alt={ChannelIcons[24].text} width="200" height="150"></img>
                                        </Link>   
                                        <p className="brand-tile-region">East</p>                                                                
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[25].href}>
                                            <img className="channel-images" src={ChannelIcons[25].image_src} alt={ChannelIcons[25].text} width="200" height="150"></img>
                                        </Link>   
                                        <p className="brand-tile-region">East</p>                                                                
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[26].href}>
                                            <img className="channel-images" src={ChannelIcons[26].image_src} alt={ChannelIcons[26].text} width="200" height="150"></img>
                                        </Link>  
                                        <p className="brand-tile-region">East</p>                                                                     
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[27].href}>
                                            <img className="channel-images" src={ChannelIcons[27].image_src} alt={ChannelIcons[27].text} width="200" height="150"></img>
                                        </Link>    
                                        <p className="brand-tile-region">West</p>                                                                   
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[28].href}>
                                            <img className="channel-images" src={ChannelIcons[28].image_src} alt={ChannelIcons[28].text} width="200" height="150"></img>
                                        </Link>  
                                        <p className="brand-tile-region">West</p>                                                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[29].href}>
                                            <img className="channel-images" src={ChannelIcons[29].image_src} alt={ChannelIcons[29].text} width="200" height="150"></img>
                                        </Link>   
                                        <p className="brand-tile-region">West</p>                                                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="brand-tile">
                            <div className="brand-tile-wrapper">
                                <div className="brand-tile-image">
                                    <div className="brand-tile-logo" style={logoStyle.container}>
                                        <Link href={ChannelIcons[30].href}>
                                            <img className="channel-images" src={ChannelIcons[30].image_src} alt={ChannelIcons[30].text} width="200" height="150"></img>
                                        </Link>  
                                        <p className="brand-tile-region">West</p>                                                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    )
  }
  
  export default Channels;